const aux = (props)  => props.children;

export default aux;




// WEBPACK FOOTER //
// ./src/components/UI/hoc/Aux/Aux.js